import React, { useState } from 'react';

import { Separator } from '@change/ds-core-ui';
import { RedditIcon } from '@change/ds-icons';

import { useI18n } from '@change-corgi/core/react/i18n';

import { HeaderLoading } from './Header.loading';
import {
	HeaderStyles,
	NotchStyles,
	NotchTextStyles,
	RedditIconStyles,
	SeparatorStyles,
	SubredditFollowersStyles,
	SubredditImageStyles,
	SubredditInfoStyles,
	SubredditNameStyles,
} from './Header.styles';
import type { RedditPostComponentsProps } from './types';

export const Header: React.FC<RedditPostComponentsProps> = (props) => {
	const { size, subreddit, loading, retryState } = props;

	const { localizeNumber } = useI18n();

	const [fallBackIcon, setFallBackIcon] = useState(false);

	const headerStyles = HeaderStyles({ size });
	const notchStyles = NotchStyles({ size });
	const notchTextStyles = NotchTextStyles({ size });

	if (loading) return <HeaderLoading size={size} retryState={retryState} />;

	return (
		<>
			<div className={headerStyles}>
				<div className={notchStyles}>
					<span className={notchTextStyles}>Example subreddit</span>
				</div>
				<div className={SubredditInfoStyles({ size })}>
					<div className={SubredditImageStyles({ size })}>
						{!fallBackIcon && subreddit.metadata.imageUrl && (
							<img
								data-testid="subreddit-image"
								src={subreddit.metadata.imageUrl}
								className="h-full w-full"
								alt=""
								aria-hidden
								onError={() => {
									setFallBackIcon(true);
								}}
							/>
						)}
						{(fallBackIcon || !subreddit.metadata.imageUrl) && (
							<div
								className="group relative grid h-full w-full place-items-center justify-center rounded-full bg-linear-to-t from-[#F00120] to-[#FE7D14] p-0 text-white"
								data-testid="reddit-icon"
							>
								<RedditIcon className={RedditIconStyles({ size })} />
							</div>
						)}
					</div>
					<div className="flex flex-col gap-px">
						<span className={SubredditNameStyles({ size })}>{subreddit.name}</span>
						{subreddit.metadata.memberCount && (
							<span className={SubredditFollowersStyles({ size })}>
								{localizeNumber(subreddit.metadata.memberCount)} followers
							</span>
						)}
					</div>
				</div>
			</div>
			<Separator className={SeparatorStyles({ size })} />
		</>
	);
};
